import React, { useLayoutEffect, useRef } from "react";

/**
 * Animates its children open/closed with a smooth height transition.
 * Content stays mounted so transitions run in both directions and any
 * input state inside is preserved while collapsed.
 */
const Collapse = ({ open, children, className = "" }) => {
  const containerRef = useRef(null);

  // Blur any focused descendant before aria-hidden/inert are applied, otherwise
  // the browser blocks aria-hidden and logs an accessibility warning.
  useLayoutEffect(() => {
    if (!open && containerRef.current?.contains(document.activeElement)) {
      document.activeElement.blur();
    }
  }, [open]);

  return (
    <div
      ref={containerRef}
      className={`smooth-collapse ${open ? "is-open" : ""} ${className}`.trim()}
      aria-hidden={!open}
      inert={!open ? "" : undefined}
    >
      <div className="smooth-collapse__inner">{children}</div>
    </div>
  );
};


export default Collapse;
